import { createSelector } from '@reduxjs/toolkit'
import type { RootState } from 'Utils/store'
import { multiSelectSlice } from 'Slices/multiSelectSlice'
import CitizenshipConfig from 'Configs/fields/citizenship_status.json'
import { ContractSource } from 'Types/contractTypes'

const contractSource = ContractSource.candidates

const transformValues = function (selectedValues) {
  return selectedValues.map((value) => (value === 'None Selected' ? '' : value))
}

export const CitizenshipSlice = multiSelectSlice(
  CitizenshipConfig.column,
  'setCitizenship',
  CitizenshipConfig.data,
  CitizenshipConfig.meta,
  transformValues
)

export const selectCitizenship = createSelector(
  ({ onDemandFilter: { demographics } }: RootState) =>
    demographics.citizenship.selectedValues,
  (
    selectedValues: string[]
  ): {
    selectedValues: string[]
    values: string[]
    audienceTypes: string[]
    label
  } => {
    return {
      selectedValues,
      values: CitizenshipConfig.data,
      audienceTypes: CitizenshipConfig.source[contractSource].audience_types,
      label: CitizenshipConfig.meta.label,
    }
  }
)

export const { setCitizenship } = CitizenshipSlice.actions

export default CitizenshipSlice.reducer
